import { AVIOS_PREFIX } from '@/constants';
import isEmpty from '../is-empty';

export type FetcherType<T> = {
  data: T;
  hasError: boolean;
};

export const newFetcher = async (
  url: string,
  method = 'GET',
  data = {},
  headers = {},
) => {
  if (url.startsWith('/api')) {
    const pathName = new URL(`${window.location.origin}${url}`).pathname;
    const uriWithoutPathName = url.replace(pathName, '');

    // eslint-disable-next-line no-param-reassign
    url = `${AVIOS_PREFIX}${pathName}${
      pathName.endsWith('/') ? '' : '/'
    }${uriWithoutPathName}`;
  }

  const requestInit = {
    method,
    headers,
    body: isEmpty(data) ? null : JSON.stringify(data),
  };
  const response = await fetch(url, requestInit);

  if (!response.ok) {
    const result = await response.json();
    const error = new Error(
      result.error ?? 'An error occurred while fetching the data.',
    );
    error.cause = result;
    throw error;
  }

  return response.json();
};

export default newFetcher;
